export enum GoogleAnalyticsEventType {
  DEFAULT = 'default',
  PURCHASE = 'purchase',
  MODIFY = 'modify',
  REFUND = 'refund',
  PAGE_VIEW = 'page_view',
  PAGE_VIEW_PARTIAL = 'page_view_partial',
  VIEW_ITEM_LIST = 'view_item_list',
  VIEW_INELIGIBLE_ITEM_LIST = 'view_ineligible_item_list',
  CHANGE_LANGUAGE = 'change_language',
  CLOSE_COOKIE_BANNER = 'close_cookie_banner',
  LINK_CLICK = 'link_click',
  TOGGLE_POINTS = 'toggle_points',
  INSUFFICIENT_POINTS = 'insufficient_points',
  VIEW_CART = 'view_cart',
  CART_CLICK = 'cart_click',
  ADD_TO_CART = 'add_to_cart',
  REMOVE_FROM_CART = 'remove_from_cart',
  BEGIN_CHECKOUT = 'begin_checkout',
  SLIDER_INTERACTION = 'slider_interaction',
  CLICK = 'click',
  PERFORMANCE = 'performance',
  CHECK_ELIGIBILITY_SUBMIT = 'check_eligibility_submit',
  CHECK_ELIGIBILITY_RESPONSE = 'check_eligibility_response',
  CONFIG = 'config',
  OPTIMIZELY = 'optimizely',
  PAYMENT_FORM_SUBMIT = 'payment_form_submit',
  OPEN_DEV_PANEL = 'open_dev_panel',
}

export enum GoogleAnalyticPage {
  LANDING = 'Landing Page',
  PAYMENT = 'Payment Page',
  CARD_DECLINE = 'Card Decline Landing Page',
  SUBMISSION = 'Submission Page',
  CONFIRMATION = 'Confirmation Page',
  ONBOARD_UPGRADE_LANDING = 'Onboard Upgrade Landing Page',
}

export enum GoogleAnalyticClick {
  LOGIN = 'log in',
  LOGOUT = 'log out',
  TERMS_AND_CONDITIONS = 'terms and conditions',
  PRIVACY_SETTINGS = 'privacy settings',
  HOW_DOES_IT_WORK = 'how does it work',
  VIEW_SEAT_MAP = 'view seat map',
  STEPPER = 'stepper',
  TRIP_ACCORDION = 'trip accordion',
  SHOW_BENEFITS = 'show benefits',
  SHOW_BENEFITS_CLOSE = 'show benefits popup close',
  CAROUSEL_CLICK = 'image carousel',
  BENEFITS_CAROUSEL_CLICK = 'benefits image carousel',
  CARD_DECLINE_NEW = 'Card Decline New Card',
  CARD_DECLINE_RETRY = 'Card Decline Retry',
  CROSS_AIRLINE_CLICK = 'cross airline click',
  GO_TO_CROSS_AIRLINE_PARTNER = 'go to cross airline partner',
  CHANGE_LANGUAGE_DROPDOWN = 'change language dropdown',
  PAY_WITH_POINTS = 'pay with points',
  PAY_WITH_POINTS_TOGGLE = 'pay with points toggle',
  PAY_WITH_POINTS_LOGIN_CONFIRM = 'pay with points login confirm',
  PAY_WITH_POINTS_LOGOUT = 'pay with points logout',
  PAY_WITH_POINTS_LOGOUT_CONFIRM = 'pay with points logout confirm',
  MANAGE_MY_BOOKING_NO_THANKS = 'manage my booking no thanks',
}

export enum GoogleAnalyticsSeatMapClick {
  ADD_SEAT = 'add_seat',
  REMOVE_SEAT = 'remove_seat',
  TOGGLE_SEATMAP = 'toggle_seatmap',
}

export enum GoogleAnalyticsCartClickLocation {
  HEADER = 'header',
  BUTTON = 'button',
}

export enum GoogleAnalyticsPerformance {
  PARTIAL_PAGE_LOAD = 'partial page load',
  FULL_PAGE_LOAD = 'full page load',
}
